<template>
    <section class="home-container">
        <MasterPage title="登陆历史">
            <div slot="title-icon">
                <Icon type="md-settings" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="8">
                        <FormItem label="用户名：">
                            <Input v-model="select.loginName" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="8">
                        <FormItem label="登陆IP：">
                            <Input v-model="select.ip" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="8">
                        <FormItem label="时间段：">
                            <DatePicker v-model="select.dataTime" type="datetimerange" placeholder="请选择预约时间段" style="width: 100%"></DatePicker>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="infoModel" title="医生详情">
            <Form :label-width="90">
                <FormItem  label="医生头像：">
                    <img :src="infoItem.imageUrl" style="max-height: 125px;max-width: 100%">
                </FormItem>
                <FormItem  label="医生姓名：">
                    {{infoItem.name}}
                </FormItem>
                <FormItem label="医生职称：">
                    {{infoItem.title}}
                </FormItem>
                <FormItem label="医生专长：">
                    {{infoItem.profession}}
                </FormItem>
                <FormItem label="医生简介：">
                    {{infoItem.introduction}}
                </FormItem>
            </Form>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '用户名',
                        key: 'loginName',
                        align: 'center',
                    },
                    {
                        title: 'ip地址',
                        key: 'ip',
                        align: 'center',
                    },
                    {
                        title: '登陆时间',
                        align: 'center',
                        render: (h, params) => {
                            let value = params.row.loginTime
                            if (value==undefined || value.length <=0) return "-"
                            let time = new Date(value)
                            let y = time.getFullYear();
                            let m = (time.getMonth()+1) < 10 ? '0' + (time.getMonth()+1):(time.getMonth()+1);
                            let d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                            let hh = time.getHours()< 10 ? '0' + time.getHours() : time.getHours()
                            let mm = time.getMinutes()< 10 ? '0' + time.getMinutes() : time.getMinutes()
                            let s = time.getSeconds()< 10 ? '0' + time.getSeconds() : time.getSeconds()
                            return h('span',y+'-'+m+'-'+d+' '+ hh +':'+mm+':'+s)
                        }
                    },
                    // {
                    //     title: '操作',
                    //     align: 'center',
                    //     render: (h, params) => {
                    //         let Buttons = [
                    //             h('Button', {
                    //                 props: {
                    //                     type: 'primary',
                    //                     icon:'ios-list-box',
                    //                     label:"small",
                    //                 },
                    //                 style: {
                    //                     marginRight: '5px'
                    //                 },
                    //                 on: {
                    //                     click: () => {
                    //                         this.infoItem_modal(this.dataList[params.index])
                    //                     }
                    //                 }
                    //             }, '详情')
                    //         ]
                    //         return h("div",Buttons)
                    //     }
                    // }
                ],
                dataList: [],
                tableLoading:false,
                infoModel:false,
                select:{
                    loginName:'',
                    ip:'',
                    dataTime:'',
                },
                infoItem:'',
                pageNum:1,
                pageSize:20,
                pageTotal:0,
            }
        },
        created(){
            this.pageFindItem()
        },
        methods:{
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('systemUser/loginLog',{
                    loginName:this.select.loginName,
                    ip:this.select.ip,
                    loginTimeStart:this.select.dataTime[0] == undefined || this.select.dataTime[0] == "" ? new Date(undefined):this.select.dataTime[0]+"",
                    loginTimeEnd:this.select.dataTime[1] == undefined || this.select.dataTime[1] == "" ? new Date(undefined):this.select.dataTime[1]+"",
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'登陆历史查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            infoItem_modal(item){
                this.infoItem = item
                this.infoModel = true
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>
